import type { SWRConfiguration } from 'swr';
import useSWR from 'swr';

import { SparksAgentService } from '@/components/composite/SparksAgent/services/SparksAgentService';

import type { ErrorCustom } from '@/utils/client';
import { get } from '@/utils/client';

import { GLOBAL_QUOTA } from '@/lib/routes/apiEndpoints';

export type GlobalAiQuota = {
    total: number | null;
    remaining: number | null;
};

export type GlobalQuotaResponse = {
    ai: GlobalAiQuota;
};

type UseGlobalAiQuotaParams = {
    shouldFetch?: boolean;
    options?: SWRConfiguration<GlobalQuotaResponse, ErrorCustom>;
};

export function useGlobalAiQuota({ shouldFetch = true, options }: UseGlobalAiQuotaParams = {}) {
    const { data, error, isLoading, mutate } = useSWR<GlobalQuotaResponse, ErrorCustom>(
        shouldFetch ? GLOBAL_QUOTA : null,
        (url) => get(url).then((res) => res.data),
        {
            shouldRetryOnError: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            ...options
        }
    );

    const aiQuota = data?.ai;
    const { isQuotaExhausted, showRemainingQuota } = SparksAgentService.getGlobalAiQuotaDerived(
        aiQuota,
        isLoading
    );

    return {
        aiQuota,
        isQuotaExhausted,
        showRemainingQuota,
        globalQuotaError: error,
        isLoadingGlobalQuota: isLoading,
        mutateGlobalQuota: mutate
    };
}
